export const FCI_APIS = {
  LACARDIO: {
    PATIENT_CREATION: (document_type: string, document_number: string) =>
      `/api/lacardio/patient-creation/${document_type}/${document_number}/`,
    PATIENT: (document_type: string, document_number: string) =>
      `/api/lacardio/patient/${document_type}/${document_number}/`
  }
} as const;
